import script from "./editFeeCharge.vue?vue&type=script&setup=true&lang=js"
export * from "./editFeeCharge.vue?vue&type=script&setup=true&lang=js"

import "./editFeeCharge.vue?vue&type=style&index=0&id=843cc65e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-843cc65e"]])

export default __exports__